import { render, staticRenderFns } from "./ProductListManage.vue?vue&type=template&id=92f23364"
import script from "./ProductListManage.vue?vue&type=script&lang=ts"
export * from "./ProductListManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports